/* eslint-disable */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router';

// Custom Components
import PhotoCentricPage from '@/ui/PhotoCentric/PhotoCentricPage';
import modelGrobnaMjesta from '@/models/groblja/grobna_mjesta';
import Permissions from '@/lib/permissions';
import UserContext from '@/context/UserContext/UserContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import AppPage from '@/ui/AppPage/AppPage';
import DialogContext from '@/context/DialogContext/DialogContext';
import DataController from '@/lib/DataController';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';

type GrobnaMjestaPhotoCentricPageParams = {};

const GrobnaMjestaPhotoCentricPage = (props: GrobnaMjestaPhotoCentricPageParams) => {
  const userContext = useContext(UserContext);

  /*const handleCustomAction = (
    action: string,
    id: number,
    record?: { [key: string]: any }
  ) => {
    let locationId: number | null = null;
    if (record && 'lokacija_id' in record) {
      locationId = record.lokacija_id as number;
    }
    switch (action) {
      case 'show_object':
        if (id) {
          const url = `${
            location.origin
          }/groblja/grobna-mjesta/?id=${id.toString()}&open_first=true`;
          window.open(url, '_blank');
        }
        break;
      case 'show_photos':
        if (id) {
          const url = `${
            location.origin
          }/ena/photodoc/?rec_id=${id.toString()}`;
          window.open(url, '_blank');
        }
        break;
      default:
        break;
    }
  };*/

  const { showDialog } = useContext(DialogContext);
  const dc = new DataController(modelGrobnaMjesta);

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };


  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id, record) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.grobna_mjesta_history',
        view: 'history',
        customPath: `${modelGrobnaMjesta.apiPath}/${id}/history`,
        tableId: 'grobna-mjesta-history',
      });
    }
  };

  const viewName = userContext?.hasAnyPermission([Permissions.ThreeDView])
    ? 'processing_with_3d'
    : 'processing';

  return (
    <AppPage titlett="ena:page.photodoc" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <PhotoCentricPage
        titleToken="titles.grobna_mjesta"
        model={modelGrobnaMjesta}
        mapId={42}
        allowCustomTableAction={allowRowAction}
        onCustomTableAction={handleRowAction}
        viewName={viewName}
        dialogHidePolygons={true}
        percentage={0.1}
        primaryAllowShow3DButton={true}
        selectedFilterInitialValue={true}
      />
    </AppPage>
  );
};

export default GrobnaMjestaPhotoCentricPage;
